<template>
<div class="chapter">
<div class="inner_page">
<p class="half"><a id="page_1"><b>The Second World War Illustrated</b></a></p><a id="page_1">
</a><p class="half1"><a id="page_1"><i>The Fifth Year</i></a><a id="page_2"></a></p><a id="page_2">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?64ce0d46